// Adding a location. Same interaction as adding a list entry, more fields underneath, because a
// location is a record rather than a value and a display name.
//
// Only the display name and the value are required: someone adding "Tema" mid-capture should not
// have to stop and find its postcode, and a half-known location is more useful than none.
//
// Latitude and longitude are deliberately absent from this form. Nothing reads them yet, and an
// input nobody can fill correctly is worse than no input; the fields exist on the record so
// capturing them later is not a schema change.

import { useState } from 'react';

import Modal from '../../ui/Modal.jsx';
import { addLocation } from '../../api.js';

export default function AddLocationDialog({ onClose, onAdded }) {
  const [form, setForm] = useState({ code: '', label: '', country: '', address: '', postcode: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);


  const set = (name) => (event) => setForm((current) => ({ ...current, [name]: event.target.value }));

  const onSubmit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onAdded(await addLocation({
        code: form.code,
        label: form.label,
        country: form.country || null,
        address: form.address || null,
        postcode: form.postcode || null,
      }));
    } catch (err) {
      setError(err.status === 409 ? 'That value is already a location.' : err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal onClose={onClose}>
      <form onSubmit={onSubmit}>
        <h3>Add a location</h3>
        <p className="hint">
          Only a display name and a value are needed; the rest can follow later.
        </p>
        <label>Display name
          <input value={form.label} onChange={set('label')} required placeholder="Tema, Ghana" />
        </label>
        <label>Value
          <input value={form.code} onChange={set('code')} required placeholder="TEMA" />
        </label>
        <label>Country
          <input value={form.country} onChange={set('country')} maxLength={2} placeholder="GH" />
        </label>
        <label>Address
          <input value={form.address} onChange={set('address')} placeholder="Port of Tema" />
        </label>
        <label>Postcode<input value={form.postcode} onChange={set('postcode')} /></label>
        {error && <p className="error">{error}</p>}
        <menu>
          <button type="button" onClick={onClose}>Cancel</button>
          <button type="submit" disabled={busy}>{busy ? 'Adding…' : 'Add'}</button>
        </menu>
      </form>
    </Modal>
  );
}
